import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Skills } from "@/components/Skills";
import { SelectedWork } from "@/components/SelectedWork";
import { Philosophy } from "@/components/Philosophy";
import { Contact } from "@/components/Contact";
import { usePageMeta } from "@/lib/motion";

export default function Home() {
  usePageMeta("Hades — Developer & Digital Creator", "Explore Hades' portfolio of websites, software projects, developer tools, and digital experiences.");
  return (
    <>
      <Hero />
      <Marquee />
      <About />
      <Skills />
      <SelectedWork />
      <Philosophy />
      <Contact />
    </>
  );
}
